module.exports = __webpack_public_path__ + "img/image3.120aaf44.jpg";